import React from "react";
import "../css/loading.scss";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="simple-loader">
        <div className="spinner"></div>
        <div className="loading-text">Loading...</div>
      </div>
    </div>
  );
};

export default Loading;
